import React from "react";
import { IMGIX_BASE_PATH } from "./constants";
import { ReactComponent as MotherlyLogo } from "../images/motherly.svg";

export const REST_FAMILY_PAGE_NAME = "Rest Family Product";
export const REST_FAMILY_PRESS_REVIEWS = [
  {
    heading: (
      <>
        &quot;We love this sound machine for its many features. Sounds, light
        color, brightness and timers can all be controlled via your
        smartphone.&quot;
      </>
    ),
    className: "parenting_slide",
    images: {
      default: `${IMGIX_BASE_PATH}/parenting-default.png`,
      hover: `${IMGIX_BASE_PATH}/parenting-navy.png`,
    },
    usePNG: true,
    title: "Parenting.com",
  },
  {
    heading: (
      <>
        &quot;A sound machine, night light, and alarm clock all rolled into one
        convenient device, the Hatch is every parent's (literal) dream.&quot;
      </>
    ),
    className: "scary_mommy_slide",
    images: {
      default: `${IMGIX_BASE_PATH}/scary-mommy-default.png`,
      hover: `${IMGIX_BASE_PATH}/scary-mommy-navy.png`,
    },
    usePNG: true,
    title: "Scary Mommy",
  },
  {
    heading: <>&quot;...it's genius.&quot;</>,
    className: "motherly_slide",
    logo: MotherlyLogo,
    usePNG: false,
    title: "Motherly",
  },
  {
    heading: (
      <>
        &quot;This versatile light and white noise machine can be controlled
        from your phone so you never have to get out of bed.&quot;
      </>
    ),
    className: "cnet_slide",
    images: {
      default: `${IMGIX_BASE_PATH}/cnet-default.png`,
      hover: `${IMGIX_BASE_PATH}/cnet-navy.png`,
    },
    usePNG: true,
    title: "CNET",
  },
];

export const REST_FAMILY_DEFAULT_HERO_IMAGES = {
  mobile: {
    image: "Rest-family-header-89-mobile.png",
    retinaImage: "Rest-family-header-89-mobile@2x.png",
  },
  tablet: {
    image: "Rest-family-header-89-tablet.png",
    retinaImage: "Rest-family-header-89-tablet@2x.png",
  },
  desktop: {
    image: "Rest-family-header-89-desktop.png",
    retinaImage: "Rest-family-header-89-desktop@2x.png",
  },
};

export const REST_FEATURES = [
  {
    label: "Sound Machine",
    icon: "sound-machine.svg",
    alt: "Sound machine",
  },
  {
    label: "Night Light",
    icon: "night-light.svg",
    alt: "Night light",
  },
  {
    label: "Time-to-Rise",
    icon: "time-to-rise-sun.svg",
    alt: "Time-to-rise",
  },
  {
    label: "Audio Monitor",
    icon: "audio-monitor.svg",
    alt: "Audio monitor",
  },
  {
    label: "Control with Alexa",
    icon: "alexa-icon.svg",
    alt: "Alexa-enabled",
  },
  {
    label: "Clock",
    icon: "time-to-rise.svg",
    alt: "Clock",
  },
];

export const REST_PLUS_MEDIA_REVIEWS = [
  {
    content:
      "“OMG this popular sound machine and night light’s upgrade is amazing.”",
    reviewer: {
      logo: "logo_romper@2x.png",
      alt: "Romper",
    },
  },
  {
    content:
      "“This is a must-have item for many parents hoping for just a little bit more sleep.”",
    reviewer: {
      logo: "logo_techcrunch@2x.png",
      alt: "TechCrunch",
    },
  },
];
